export default __webpack_public_path__ + "static/media/linkedIn.e4aac48c.svg";